import { render } from "./MessageFileSelectorPopUp.vue?vue&type=template&id=b56db41a&ts=true"
import script from "./MessageFileSelectorPopUp.vue?vue&type=script&lang=ts"
export * from "./MessageFileSelectorPopUp.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__